import React from 'react';
import { FormField } from '../../components/FormField';

interface ApartmentCriteriaProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ApartmentCriteria: React.FC<ApartmentCriteriaProps> = ({
  formData,
  handleInputChange,
}) => {
  const criteria = [
    { name: 'hasElevator', label: 'Ascenseur' },
    { name: 'hasBalcony', label: 'Balcon' },
    { name: 'hasTerrace', label: 'Terrasse' },
    { name: 'hasRoofTerrace', label: 'Terrasse sur le toit' },
    { name: 'hasAirConditioning', label: 'Climatisation' },
    { name: 'hasGasHeating', label: 'Chauffage au gaz' },
    { name: 'isGroundFloor', label: 'Rez-de-chaussée' },
    { name: 'isTopFloor', label: 'Dernier étage' },
    { name: 'hasPrivateParking', label: 'Parking privé' },
    { name: 'hasGuardian', label: 'Gardien' },
    { name: 'hasIntercom', label: 'Interphone' },
    { name: 'hasInterphone', label: 'Visiophone' },
    { name: 'hasDigicode', label: 'Digicode' },
    { name: 'hasVideoSurveillance', label: 'Vidéo Surveillance' },
    { name: 'hasTrustee', label: 'Syndic' },
    { name: 'hasCistern', label: 'Citerne' },
    { name: 'hasWaterTank', label: 'Bâche à eau' },
    { name: 'hasDoubleGlazing', label: 'Double vitrage' },
    { name: 'hasElectricShutters', label: 'Volets électriques' },
    { name: 'hasSeaView', label: 'Vue Mer' },
    { name: 'hasPool', label: 'Piscine' },
  ];

  return (
    <FormField label="Critères">
      <div className="grid grid-cols-2 gap-4">
        {criteria.map(({ name, label }) => (
          <label key={name} className="flex items-center gap-2">
            <input
              type="checkbox"
              name={name}
              checked={formData[name] || false}
              onChange={handleInputChange}
            />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </FormField>
  );
};